// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.play-btn {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}

.game-tile-overlay {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.game-tile-placeholder:hover .play-btn {
  display: block;
}

.game-tile {
  position: relative;
  border-radius: 10px;
  -moz-border-radius: 10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.7s;
}

/* css class 'ios-web-ele-touched', 'not-ios-web' are from directive 'appIosWebTouchDetect'*/
.game-tile-placeholder.ios-web-ele-touched .play-btn,
.game-tile-placeholder.not-ios-web:hover .play-btn {
  display: block;
}

.game-tile-placeholder.ios-web-ele-touched .game-tile,
.game-tile-placeholder.not-ios-web:hover .game-tile,
.game-tile-placeholder:focus .game-tile {
  transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./src/app/components/casino-lobby/ld-game-tile/ld-game-tile.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA;EACI,cAAA;AAAJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EAIA,oBAAA;AACJ;;AAGA,4FAAA;AACA;;EAEI,cAAA;AAAJ;;AAGA;;;EAGI,qBAAA;AAAJ","sourcesContent":[".play-btn {\n    display: none;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 99;\n}\n\n.game-tile-overlay {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n\n.game-tile-placeholder:hover .play-btn {\n    display: block;\n}\n.game-tile{\n    position: relative;\n    border-radius: 10px;\n    -moz-border-radius: 10px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    -webkit-transition: all .7s;\n    -moz-transition: all .7s;\n    -o-transition: all .7s;\n    transition: all .7s;\n}\n\n\n/* css class 'ios-web-ele-touched', 'not-ios-web' are from directive 'appIosWebTouchDetect'*/\n.game-tile-placeholder.ios-web-ele-touched .play-btn,\n.game-tile-placeholder.not-ios-web:hover .play-btn {\n    display: block;\n}\n\n.game-tile-placeholder.ios-web-ele-touched .game-tile,\n.game-tile-placeholder.not-ios-web:hover .game-tile,\n.game-tile-placeholder:focus .game-tile {\n    transform: scale(1.1);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
